/* eslint-disable @typescript-eslint/camelcase */
const data = {
  'bh.queueMinutesShift': 'Posun otev./zavř. fronty (min)',
  'bh.onlineCheckinMinutesShift': 'Posun pro online klienty (min)',
  'bh.doNotCloseOnBreak': 'Nezavírat frontu o přestávkách',
  'bh.resetQueueOnFirstDayOpen': 'Smazat lístky při prvním otevření',
  'tip.onlineCheckinMinutesShift':
    'Posun otev./zavř. fronty v minutách pro online klienty vůči otevíracím hodinám. Záporné číslo znamená otevřít/zavřít frontu dříve, kladné později proti otevíracím hodinám.',
  'tip.doNotCloseOnBreak': 'Nezavírat frontu pro check-in o přestávkách během dne',
  'tip.resetQueueOnFirstDayOpen': 'Smazat lístky při prvním otevření fronty v daném dni',
  'tip.queueMinutesShift':
    'Posun otev./zavř. fronty  v minutách vůči otevíracím hodinám. Záporné číslo znamená otevřít/zavřít frontu dříve, kladné později proti otevíracím hodinám.',
  'tip.openShift': 'Posun otevření',
  'tip.closeShift': 'Posun zavření',
  'tip.calExceptions':
    'Dny odlišné od běžného kalendáře. Pokud zadáte čas od - do, pak tento čas definuje dobu oteření.\nPokud nezadáte čas, bude v zadaném období zavřeno',
  'calExceptions.displayTime.label': 'Zobrazit / skrýt čas',
  'calExceptions.timeHidden.note': 'V zadaném období bude zavřeno',
  'calExceptions.timeShown.note': 'V zadaném období bude v daném čase otevřeno',
  'calException.open': 'Otevřeno pouze:',
  'datePicker.timeTitle': 'Čas',
  'Connected to cloud': 'Připojen k internetu',
  'deviceStatusResult.printer.header': 'Tiskárna: %{name}',
  'deviceStatusResult.cloud-qsrv.header': 'Cloud server NextInQ',
  'deviceStatusResult.display.header': 'Displej: %{name}',
  'deviceStatusResult.kiosk.header': 'Panel kiosku: %{name}',
  'deviceStatusCheck.printer-offline': 'Tiskárna je offline',
  'deviceStatusCheck.printer-coverOpen': 'Otevřené víko',
  'deviceStatusCheck.printer-cutterError': 'Chyba řezače lístků',
  'deviceStatusCheck.printer-unrecoverableError': 'HW chyba kiosku',
  'deviceStatusCheck.printer-highTempOrVoltage': 'Vysoká teplota tiskárny',
  'deviceStatusCheck.printer-noPaper': 'Chybí paír v tiskárně',
  'deviceStatusCheck.printer-paperNearEnd': 'Dochází papír tiskárny',
  'deviceStatusCheck.kiosk.web.onlineOffline.reason.error': 'Tiskárna není připravena',
  'deviceStatusResult.ok': 'Zařizení je připojené',
  deviceDisconnected: 'Zařízení není připojené.',
  'Broken connection to cloud': 'Přerušeno spojení k internetu',
  refresh: 'Obnovit',
  created: 'Vytvořen',
  'clearTickets.label': 'Smazat lístky z fronty',
  'clearTickets.title': 'Smazat lístky z fronty',
  'clearTickets.subtitle': 'Chcete smazat všechny lístky ve vybrané frontě?',
  'errors.auth.invalidCredentials': 'Chybné ID nebo heslo přepážky',
  // One key per `err-*` code the server's booth handlers answer with
  // (packages/server/src/ws/handlers/booth.ts). The server's own message is
  // English and only the fallback for a code missing here.
  'errors.err-queue-empty': 'Ve frontě nikdo nečeká',
  'errors.err-no-current-ticket': 'Právě nikoho neobsluhujete',
  'errors.err-no-previous-ticket': 'Žádný předchozí lístek',
  'errors.err-no-queue': 'Přepážka nemá přiřazenou frontu',
  'errors.err-queue-not-found': 'Fronta neexistuje',
  'errors.err-ticket-not-found': 'Lístek už ve frontě není',
  'errors.err-comment-not-found': 'Komentář neexistuje',
  'errors.err-invalid-request': 'Neplatný požadavek, zkuste to prosím znovu',
  'resetQueue.label': 'Reset fronty',
  'resetQueue.title': 'Reset fronty',
  'resetQueue.subtitle':
    'Chcete smazat všechny lístky ve vybrané frontě a vynulovat počitadlo fronty? Čísla nových lístků budou začínat od 1',
  'forceOpenQueue.label': 'Otevřít frontu',
  'forceOpenQueue.title': 'Otevřít frontu - nezávisle na nastavení kalendáře',
  'forceOpenQueue.subtitle':
    'Fronta bude otevřena po zbytek dne bez ohledu na nastavení kalendáře. Následující den se bude opět otevírat dle kalendáře.',
  'forceCloseQueue.label': 'Zavřít frontu',
  'forceCloseQueue.title': 'Zavřít frontu - nezávisle na nastavení kalendáře',
  'forceCloseQueue.subtitle':
    'Fronta bude zavřena po zbytek dne bez ohledu na nastavení kalendáře. Následující den se bude opět otevírat/zavírat dle kalendáře.',
  'backToAutoOpening.label': 'Otevírat/zavírat frontu dle kalendáře',
  'backToAutoOpening.title': 'Otevírat/zavírat frontu dle kalendáře',
  'backToAutoOpening.subtitle':
    'Fronta se bude otevírat/zavírat dle nastavení kalendáře. Zruší manuální otevření/zavření fronty.',
  'queueHeader.ticketNote.hintText': 'Vaše poznámka k lístku, např. p. Novák ...',
  'queueHeader.ticketNote.floatingLabel': 'Poznámka (nepovinná)',
  'queueStatus.closed': 'Zavřeno',
  'queueStatus.open': 'Otevřeno',
  'queueStatus.closedByCalendar': 'Zavřeno',
  'queueStatus.openByCalendar': 'Otevřeno',
  'queueStatus.closedManually': 'Zavřeno obsluhou',
  'queueStatus.openManually': 'Otevřeno obsluhou',
  'queueStatus.manualLockDetail': '(návrat ke kalendaři po %{lockDate})',
  'queueStatus.resetQueue': 'Vynulovat počítadlo',
  'queueStatusAction.showQueueSettings': 'Nastavení',
  'queueActions.callNext': 'Další',
  'queueActions.callAgain': 'Znovu',
  'queueActions.callPrevious': 'Předchozí',
  'queueStatusAction.close': 'Zavřít frontu',
  'queueStatusAction.open': 'Otevřít frontu',
  'queueInfoButton.queueSize': 'délka fronty',
  'selectedQueue.queueHeader': 'Fronta č. %{id}',
  'queueSettingsPage.header': 'Nastavení (%{name})',
  'queueSettingsPage.calendarSectionHeader': 'Kalendář',
  'queueSettingsPage.calendarExceptions': 'Výjimky',
  'queueSettingsPage.entries': 'Otevírací hodiny',
  'queueSettingsPage.queueName': 'Název fronty',
  'queueSettingsPage.queuePrefix': 'Prefix fronty',

  'queueSettingsPage.queuePrefix.helperText':
    'Čísla lístků budou začínat tímto prefixem, např. A01, A02, ... Pokud prefix necháte prázdný, bude řada vypadat takto: 01, 02, ...',

  'queueTickets.tickets': 'Zařazení zákazníci',
  'queueTickets.commentCount': '%{smart_count} komentář |||| %{smart_count} komentáře |||| %{smart_count} komentářů',
  'queueTickets.callTicket': 'Zavolat',
  'queueTickets.removeTicketTitle': 'Odstranit lístek',
  'queueTickets.removeTicketHint': 'Chcete skutečně odstranit lístek %{number} z fronty %{queueId}?',
  'localStatus.local': 'vystaven zde',
  'localStatus.remote': 'vystaven vzdáleně',
  'pages.queues': 'Fronty',
  'pages.queueSettings': 'Nastavení (%{name})',
  'calException.closed': 'Celý den zavřeno',
  'pages.providerMessage': 'Oznámení',
  'pages.calendar': 'Rezervace',
  'pages.settings': 'Nastavení',
  'printedStatus.printed': 'vytištěn',
  'printedStatus.notPrinted': 'neni vytištěn',
  'providerMessage.header': 'Oznámení zákazníkům',
  'providerMessage.textLabel': 'Text oznámení',
  'selectedQueue.authError': 'Chyba autentizace',
  'selectedQueue.authErrorHeader': 'Zřejmě jste zadali nesprávné autentizační údaje',
  'selectedQueue.authErrorCheckCredentials': 'Zkontrolujte, že jste zadali správné id a klíč',
  'selectedQueue.noQueueFound': 'Žádná fronta nebyla nalezena',
  'selectedQueue.notProvisioned': 'Přepážka není nastavená',
  'selectedQueue.notProvisionedHeader': 'Chybí ID přepážky nebo heslo',
  'selectedQueue.notProvisionedDetails': 'Zadejte ID přepážky a heslo v Nastavení',
  'selectedQueue.boothClosed': 'Přepážka je zavřená',
  'selectedQueue.boothClosedDescription':
    'Přepážka se uzavře automaticky po několika minutách po uzavření aplikace nebo pomocí tlačítka "Uzavřít přepážku".',
  'selectedQueue.openBooth': 'Otevřít přepážku',
  'selectedQueue.noQueueFoundDetailsHeader': 'Nenalezli jsme žádnou připojenou frontu',
  'selectedQueue.noQueueFoundDetailsCBXPower': 'Zkontrolujte, že je ovládací panel zapnutý',
  'selectedQueue.noQueueFoundDetailsNoConnection': 'Zkontrolujte internetové připojení',
  'selectedQueue.noQueueFoundDetailsSettings': 'Zkontrolujte nastavení připojení k ovládacímu panelu',
  'selectedQueue.goToSettings': 'Přejít k nastavení',
  'selectedQueue.tryAgain': 'se zkuste připojit znovu',
  'selectedQueue.orDivider': 'nebo',
  'currentTicket.title': 'Právě obsluhujeme:',
  'addTicket.title': 'Přidat nový lístek na konec fronty',
  'addTicket.subtitle': 'Chcete vytvořit nový lístek a přidat ho na konec fronty?',
  'currentTicket.previousTicket': 'Předchozí lístek:',
  settings: 'Nastavení',
  tryAgain: 'Zkusit znovu',
  back: 'Zpět',
  save: 'Uložit',
  'notifications.off': 'Vypnout',
  'notifications.sound.doorBell': 'Zvuk - domovní zvonek',
  'settingsPage.settings': 'Nastavení',
  'settingsPage.wsUrl.floatingLabel': 'Adresa QSRV',
  'settingsPage.wsUrl.hintText': 'wss://api.nextinq.com/device-relay',
  'settingsPage.boothId.floatingLabel': 'Id přepážky (např. booth-1)',
  'settingsPage.boothId.hintText': 'Jednoznačné id přepážky',
  'settingsPage.cbxUUID.floatingLabel': 'CBX id (pro autentizaci)',
  'settingsPage.cbxUUID.hintText': 'např. cbx1',
  'settingsPage.boothSecret.floatingLabel': 'Heslo přepážky',
  'settingsPage.boothSecret.hintText': 'Heslo přepážky',
  'settingsPage.language': 'Jazyk',
  'settingsPage.showAdvancedSection': 'Rozšířené nastavení',
  'settingsPage.notifications': 'Zvukové oznámení',
  'settingsPage.notifications.hintText': 'Oznámení po zařazení zákazníka do fronty',
  'queueListPage.commentsHeader': 'Chat',
  'validUntil.title': 'Platnost do',
  'validUntil.neverShow': 'nikdy nezobrazovat',
  'validUntil.today': 'dnes',
  'validUntil.tomorrow': 'do zítra',
  'validUntil.custom': 'do %{validUntil}',
  'validUntil.forever': 'stále',
  'validUntil.never': 'nikdy',
  validFrom: 'Od',
  validTo: 'Do',
  'commentVisibility.all': 'vše',
  'commentVisibility.queue': 'fronta %{queue}',
  'commentVisibility.ticket': 'lístek %{ticket}',
  'commentListItem.editComment': 'Upravit',
  'commentListItem.deleteComment': 'Smazat',
  'commentListItem.visibleForAll': 'Zobrazit všem frontám',
  'commentListItem.changeValidity': 'Změnit dobu platnosti',
  'commentListItem.changeVisibility': 'Změnit viditelnost',
  'dialog.editComment.title': 'Upravit komentář',
  'dialog.editComment.message': '',
  'dialog.deleteComment.title': 'Smazat komentář?',
  'dialog.deleteComment.message': '',
  'dialog.changeValidity.title': 'Změnit dobu platnosti komentáře?',
  'dialog.changeValidity.message': 'Komentář bude viditelný po zadanou dobu platnosti',
  'dialog.changeVisibility.title': 'Změnit viditelnost komentáře?',
  'dialog.changeVisibility.message': 'Rozšířit oprávnění zobrazení komentáře pro uživatele ze všech front?',
  'button.ok': 'Ok',
  'button.cancel': 'Zrušit',
  'button.save': 'Uložit',
  'button.delete': 'Smazat',
  'button.applyCalendarChanges': 'Uložit a aplikovat změny kalendáře',
  'button.removeTicket': 'Odstranit',
  'button.closeBooth': 'Zavřít přepážku',
  'dialog.closeBooth.title': 'Zavřít přepážku?',
  'addComment.fullView': 'Zpráva všem',
  'addComment.simpleView': 'Zpráva pro %{ticketNumber}',
  'appError.allQueuesEmpty': 'Fronta je prázdná, nikdo tu nečeká ...',
  'days.Mon': 'Po',
  'days.Tue': 'Út',
  'days.Wed': 'St',
  'days.Thu': 'Čt',
  'days.Fri': 'Pá',
  'days.Sat': 'So',
  'days.Sun': 'Ne',
  'updateTicket.title': 'Přidat/upravit poznámku',
  'updateTicket.subtitle': 'Poznámka pro vás - nezobrazuje se zákazníkovi',
  'updateTicket.hintText': 'Poznámka k tomuto lístku',
  'updateTicket.floatingLabel': 'Poznámka k tomuto lístku',
  eventForm: {
    formTitle: 'Rezervace',
    title: 'Název',
    start: 'Začátek',
    end: 'Do',
    status: 'Stav',
    serviceId: 'Služba',
    clientId: 'Klient',
    resource: 'Zdroj/Osoba',
    notes: 'Poznámky',
    submit: 'Odeslat'
  },
  calNavBar: {
    today: 'Dnes',
    views: {
      month: 'Měsíc',
      week: 'Týden',
      day: 'Den',
      agenda: 'Agenda'
    }
  },
  resourceList: {
    title: 'Zaměstnanci',
    ALL: 'Všichni zaměstnanci'
  },
  rbcMessages: {
    date: 'Datum',
    time: 'Čas',
    event: 'Rezervace',
    allDay: 'Celý den',
    week: 'Týden',
    work_week: 'Pracovné dny',
    day: 'Den',
    month: 'Měsíc',
    previous: 'Předchozí',
    next: 'Následující',
    yesterday: 'Včera',
    tomorrow: 'Zítra',
    today: 'Dnes',
    agenda: 'Agenda',
    noEventsInRange: 'žádné rezervace ve zvoleném časovém rozsahu'
  },
  agendaPrintDlg: {
    formTitle: 'Tlač agendy',
    date: 'Datum',
    resource: 'Zaměstnanec',
    print: 'Tlačit'
  },
  agendaPrint: {
    loading: 'Nahrávám agendu...'
  },
  api: {
    fetchResources: {
      failed: 'Selhalo načtení seznamu zaměstnancu'
    },
    fetchEvents: {
      failed: 'Selhalo načtení rezervací.'
    },
    fetchServices: {
      failed: 'Selhalo načtení seznamu služeb.'
    },
    saveEvents: {
      failed: 'Selhalo vytvoření rezervace.'
    },
    failed: 'Selhalo spojení se serverem.'
  }
};

export default data;
